import useTranslation from 'next-translate/useTranslation'

interface IProps {
  data: any[]
  className?: string
  color?: string | null
  langKey?: string
  listClass?: string
  label?: string | null
}

const ListCheck = ({
  data,
  className,
  color = null,
  langKey,
  listClass = '',
}: IProps) => {
  const { t } = useTranslation()

  return (
    <>
      <style jsx>{`
        .list--check {
          --custom-bg: ${color || '#726EFF'};
          --border-color: '#fff';
        }
      `}</style>
      <div className={`list--check ${className}`}>
        <ul className={`w-full flex flex-wrap ${listClass}`}>
          {data.map((item, index) => (
            <li key={index} className={`w-1/2 ${color ? 'no-default' : ''}`}>
              {color && (
                <span
                  className='check'
                  style={{ backgroundColor: `#${color.replace('#', '')}` }}
                />
              )}
              {typeof item === 'object' ? (
                <span>
                  {t(`${langKey}:${item.label}`)}: {item.value}
                </span>
              ) : (
                <span>{langKey ? t(`${langKey}:${item}`) : item}</span>
              )}
            </li>
          ))}
        </ul>
      </div>
    </>
  )
}

export default ListCheck
